import { Content } from "@/store/model/Content";

export class Source {

    constructor(data) {
        this.argumentId = data.argumentId;
        this.content = new Content(data.content);
        this.coordinates = data.coordinates;
        this.externalDocSourceRelationId = data.externalDocSourceRelationId;
        this.id = data.id;
        this.proposalId = data.proposalId;
    }
}